export enum PageRoutes {
  theCamp = '/the-camp',
  whoWeAre = '/the-camp/who-are-we',
  camp67AndKumbh = '/the-camp/camp67-and-kumbh',
  camp67AndTheLand = '/the-camp/camp67-and-the-land',
  kumbh2025 = '/kumbh-2025',
  sacredGatheringOfMaghMela = '/kumbh-2025/sacred-gathering-of-magh-mela',
  basantPanchami = '/kumbh-2025/basant-panchami',
  maghiPurnima = '/kumbh-2025/maghi-purnima',
  mahaShivratri = '/kumbh-2025/maha-shivratri',
  makarSankranti = '/kumbh-2025/makar-sankranti',
  mauniAmavasya = '/kumbh-2025/mauni-amavasya',
  paushPurnima = '/kumbh-2025/paush-purnima',
  dormSingle = '/packages/dormitory-single',
  privateGroup = '/packages/private-group-cottage',
  dormBunk = '/packages/dormitory-bunk',
  twinRoom = '/packages/twin-cottage',
  premiumTwinRoom = '/packages/premium-cottage',
  familyRoom = '/packages/family-cottage',
  // familyRoomPlus = '/packages/family-cottage-plus',
  contactUs = '/contact-us',
  packages = '/packages',
  reservation = '/packages/reservation',
}
